import ga from "../../shared/analytics";
import icons from "./icons";
import PropTypes from "prop-types";
import React from "react";

import "./social.scss";

const Social = ({ socials }) => {
  if (!socials || socials.length === 0) return null;
  const track = (social) => {
    ga.social(social, "View");
  };

  const buildSocial = (socials) => {
    return socials.map((social) => (
      <li class={social.type} key={social.type}>
        <a
          href={social.url}
          title={social.type}
          aria-label={`visit our ${social.type} page`}
          onClick={track.bind(this, social.type)}
          target="_blank"
        >
          {icons[social.type]}
        </a>
      </li>
    ));
  };

  return (
    <div className="social">
      <ul>{buildSocial(socials)}</ul>
    </div>
  );
};

Social.propTypes = {
  socials: PropTypes.array.isRequired,
};

export default Social;



// WEBPACK FOOTER //
// ./src/components/shared/social/social.js